import { Components } from '@mui/material';

export const MuiAccordionSummaryTheme: Components['MuiAccordionSummary'] = {
  styleOverrides: {
    root: {
      width: '100%',
      padding: '0rem 2rem',
    },
  },
};
